import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import en from './locales/en/translation.json';
import gr from './locales/gr/translation.json';
import es from './locales/es/translation.json';
import de from './locales/de/translation.json';

const resources = {
  en: { translation: en },
  gr: { translation: gr },
  es: { translation: es },
  de: { translation: de },
};

const savedLang = localStorage.getItem('i18nextLng');

i18n
  .use(initReactI18next)
  .init({
    resources,
    lng: savedLang || 'en',
    fallbackLng: 'en',
    interpolation: {
      escapeValue: false,
    },
  });

// Listen for language changes and persist them
i18n.on('languageChanged', (lng) => {
  localStorage.setItem('i18nextLng', lng);
});

export default i18n;
